import React, { useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { useQuery } from "react-query"
import GlobalHelper from "../../common/GlobalHelper"
import { SelectOption } from "../../common/types/select/types"
import LocationSelect from "../../integration/LocationSelect"
import IntlProps from "../../state/helpers/IntlProps"
import { FeatureSentInvoiceExport } from "../../state/integration/IntegrationFeatureKeys"
import LocationService from "../../state/location/LocationService"
import { BULK_OPERATION_TYPE } from "../../utils/automation/bulk/constants"


type onChangeParam = {
    locationId: string
}

type OwnProps = {
    onChange: (param: onChangeParam) => void
    operationType: string
}

const BulkEditLocation = (props: OwnProps & IntlProps) => {

    const [selectedLocation, setSelectedLocation] = useState<SelectOption<string>>()

    const { data : locations, isLoading : isLoadingLocations} = useQuery(["getLocations"], async () => {
        return LocationService.fetchAllLocations(true)
    })

    const handleSelectChange = (location: SelectOption<string> ) => {
        const selectedLocation = locations?.find(loc => loc.getId() === location.value)

        if (selectedLocation?.isDeleted() || !selectedLocation?.getEnabled()) {
            return
        }

        setSelectedLocation(location)
        props.onChange({locationId: location.value})
    }

    return <div>
        { GlobalHelper.getIntegrationsWithEnabledFeature(FeatureSentInvoiceExport).length > 0 &&
        props.operationType == BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION && (
            <div className={"row d-flex justify-content-center"}>
                <div className={"col-8 pb-4 text-center"}>
                    <em>
                        <FormattedMessage
                            id="bulk.operations.edit_location_note"
                            defaultMessage="The document's location will be changed only in QuoteMachine.
                        This change will not affect the corresponding transaction in your integration."
                        />
                    </em>
                </div>
            </div>
        )}

        <div className="form-group row mb-1">
            <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                <FormattedMessage
                    id="bulk.operations.edit_location_label"
                    defaultMessage="Location"
                />
            </label>
            <div className="col-12 col-md-9 mb-3">
                <LocationSelect
                    selectedLocationIds={selectedLocation}
                    isLoadingLocations={isLoadingLocations}
                    locations={locations}
                    multi={false}
                    onSelect={(location) => {
                        handleSelectChange(location)
                    }}
                />
            </div>
            {props.operationType == BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION && <div className={"pt-4 text-right"}>
                <em>
                    <FormattedMessage
                        id="bulk.operations.edit_location_refresh_note"
                        defaultMessage="When the bulk operation has finished, refresh the page to see the updated location."
                    />
                </em>
            </div>}
        </div>

    </div>
}

export default injectIntl(BulkEditLocation)


// WEBPACK FOOTER //
// ./src/bulk/operations/BulkEditLocation.tsx